import { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { useAuthStore } from '@/shared/stores/auth.store'

export function LoginPage() {
  const [email, setEmail] = useState('')
  const [password, setPassword] = useState('')
  const [error, setError] = useState('')
  const [loading, setLoading] = useState(false)
  const setAuth = useAuthStore(s => s.setAuth)
  const navigate = useNavigate()

  // Check for OAuth error in URL
  const params = new URLSearchParams(window.location.search)
  const authError = params.get('auth_error')

  const handleEmailLogin = async (e: React.FormEvent) => {
    e.preventDefault()
    setLoading(true)
    setError('')
    try {
      const res = await fetch('/auth/login', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email, password }),
        credentials: 'include',
      })
      if (!res.ok) {
        const err = (await res.json()) as { error: string }
        setError(err.error ?? 'Erreur de connexion')
        return
      }
      const data = (await res.json()) as {
        accessToken: string
        user: { id: string; email: string; name: string; role?: string }
      }
      setAuth(
        {
          id: data.user.id,
          email: data.user.email,
          name: data.user.name,
          role: (data.user.role ?? 'user') as 'admin' | 'user',
        },
        data.accessToken,
      )
      navigate('/chat')
    } catch {
      setError('Impossible de se connecter au serveur')
    } finally {
      setLoading(false)
    }
  }

  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        height: '100vh',
        background: 'var(--color-bg-base)',
      }}
    >
      <div
        style={{
          background: 'var(--color-bg-surface)',
          border: '1px solid var(--color-border)',
          borderRadius: 'var(--radius-xl)',
          padding: 'var(--space-10)',
          width: 400,
          maxWidth: '90vw',
        }}
      >
        <div style={{ textAlign: 'center', marginBottom: 'var(--space-8)' }}>
          <img
            src="/app/logo-motherboard.png"
            alt="Motherboard"
            style={{
              height: 32,
              objectFit: 'contain',
            }}
          />
        </div>

        {/* OAuth Google */}
        <a
          href="/auth/google"
          style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            gap: 'var(--space-2)',
            padding: 'var(--space-3) var(--space-4)',
            background: 'var(--color-bg-elevated)',
            border: '1px solid var(--color-border-active)',
            borderRadius: 'var(--radius-md)',
            color: 'var(--color-text-primary)',
            textDecoration: 'none',
            fontFamily: 'var(--font-sans)',
            fontSize: 'var(--text-sm)',
            fontWeight: 500,
            marginBottom: 'var(--space-6)',
            transition: 'background var(--duration-fast) var(--ease-default)',
          }}
        >
          Continuer avec Google
        </a>

        <div
          style={{
            textAlign: 'center',
            color: 'var(--color-text-muted)',
            fontSize: 'var(--text-xs)',
            marginBottom: 'var(--space-4)',
          }}
        >
          ou
        </div>

        {/* Email/mdp */}
        <form
          onSubmit={handleEmailLogin}
          style={{ display: 'flex', flexDirection: 'column', gap: 'var(--space-3)' }}
        >
          <input
            type="email"
            value={email}
            onChange={e => setEmail(e.target.value)}
            placeholder="Email"
            required
            style={{
              padding: 'var(--space-3)',
              background: 'var(--color-bg-elevated)',
              border: '1px solid var(--color-border)',
              borderRadius: 'var(--radius-md)',
              color: 'var(--color-text-primary)',
              fontFamily: 'var(--font-sans)',
              fontSize: 'var(--text-sm)',
              outline: 'none',
            }}
          />
          <input
            type="password"
            value={password}
            onChange={e => setPassword(e.target.value)}
            placeholder="Mot de passe"
            required
            style={{
              padding: 'var(--space-3)',
              background: 'var(--color-bg-elevated)',
              border: '1px solid var(--color-border)',
              borderRadius: 'var(--radius-md)',
              color: 'var(--color-text-primary)',
              fontFamily: 'var(--font-sans)',
              fontSize: 'var(--text-sm)',
              outline: 'none',
            }}
          />
          {(error || authError) && (
            <p style={{ color: 'var(--color-error)', fontSize: 'var(--text-xs)', margin: 0 }}>
              {error || authError}
            </p>
          )}
          <button
            type="submit"
            disabled={loading}
            style={{
              padding: 'var(--space-3)',
              background: 'var(--color-accent)',
              border: 'none',
              borderRadius: 'var(--radius-md)',
              color: '#fff',
              fontFamily: 'var(--font-sans)',
              fontSize: 'var(--text-sm)',
              fontWeight: 600,
              cursor: loading ? 'not-allowed' : 'pointer',
              opacity: loading ? 0.7 : 1,
            }}
          >
            {loading ? 'Connexion...' : 'Se connecter'}
          </button>
        </form>
      </div>
    </div>
  )
}
